import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TakeoffLandArea } from '../models/takeoff-land-area.model';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { RunwayService } from '../service/runway.service';
import { LatLon } from '../../util/geodesy/latlon';
var EditTakeoffLandAreaComponent = /** @class */ (function () {
    function EditTakeoffLandAreaComponent(_matDialogRef, _snackBar, data, _runwayService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._runwayService = _runwayService;
        this.isNew = false;
        this.isLoading = true;
        this.takeoffLandArea = data.takeoffLandArea || new TakeoffLandArea();
        this.isNew = data.isNew || false;
        this.runwayId = data.runwayId;
        this.airportId = data.airportId;
        this.origtakeoffLandArea = Object.assign(new TakeoffLandArea, data.takeoffLandArea);
        if (this.takeoffLandArea.location != null) {
            this.latitude = this.takeoffLandArea.location.lat;
            this.longitude = this.takeoffLandArea.location.lon;
        }
        else {
            this.latitude = null;
            this.longitude = null;
        }
        if (this.isNew) {
            this.selectedTrafficPatternDirection = '';
            this.selectedMarkingsCondition = '';
            this.selectedIlsType = '';
        }
        else {
            this.selectedTrafficPatternDirection = this.getTrafficPatternDirection(this.takeoffLandArea.trafficPatDirFixed);
            this.selectedMarkingsCondition = this.getMarkingsCondition(this.takeoffLandArea.markingsCondition);
            this.selectedIlsType = this.getIlsType(this.takeoffLandArea.ilsType);
        }
    }
    EditTakeoffLandAreaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            name: new FormControl(this.takeoffLandArea.name, [Validators.required, Validators.maxLength(10)]),
            latitude: new FormControl(this.latitude, [Validators.required, Validators.pattern('^-?\\d{0,3}\\.?\\d{0,7}$')]),
            longitude: new FormControl(this.longitude, [Validators.required, Validators.pattern('^-?\\d{0,3}\\.?\\d{0,7}$')]),
            trafficPatternDirection: new FormControl(this.selectedTrafficPatternDirection),
            elevation: new FormControl(this.takeoffLandArea.elevation, [Validators.pattern('^\\d{0,10}\\.?\\d{0,1}$')]),
            trueAlignment: new FormControl(this.takeoffLandArea.trueAlignment, [Validators.required, Validators.pattern('^\\d{0,3}$')]),
            markingsType: new FormControl(this.takeoffLandArea.markingsType, [Validators.maxLength(30)]),
            markingsCondition: new FormControl(this.selectedMarkingsCondition),
            ilsType: new FormControl(this.selectedIlsType),
            gradient: new FormControl(this.takeoffLandArea.gradient, [Validators.pattern('^\\d{0,4}\\.?\\d{0,2}$')])
        });
        this.isLoading = false;
    };
    EditTakeoffLandAreaComponent.prototype.getTrafficPatternDirection = function (dir) {
        return TakeoffLandArea.formatTrafficPatternDirection(dir);
    };
    EditTakeoffLandAreaComponent.prototype.setTrafficPatternDirection = function (dir) {
        return TakeoffLandArea.parseTrafficPatternDirection(dir);
    };
    EditTakeoffLandAreaComponent.prototype.getMarkingsCondition = function (condition) {
        return TakeoffLandArea.formatRunwayMarkingsCondition(condition);
    };
    EditTakeoffLandAreaComponent.prototype.setMarkingsCondition = function (condition) {
        return TakeoffLandArea.parseRunwayMarkingsCondition(condition);
    };
    EditTakeoffLandAreaComponent.prototype.getIlsType = function (type) {
        return TakeoffLandArea.formatILSType(type);
    };
    EditTakeoffLandAreaComponent.prototype.setIlsType = function (type) {
        return TakeoffLandArea.parseILSType(type);
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditTakeoffLandAreaComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        result = void 0;
                        this.takeoffLandArea.name = this.formGroup.value.name;
                        this.takeoffLandArea.location = new LatLon(this.formGroup.value.latitude, this.formGroup.value.longitude);
                        this.takeoffLandArea.trafficPatDirFixed = this.setTrafficPatternDirection(this.formGroup.value.trafficPatternDirection);
                        this.takeoffLandArea.elevation = this.formGroup.value.elevation;
                        this.takeoffLandArea.trueAlignment = this.formGroup.value.trueAlignment;
                        this.takeoffLandArea.markingsType = this.formGroup.value.markingsType;
                        this.takeoffLandArea.markingsCondition = this.setMarkingsCondition(this.formGroup.value.markingsCondition);
                        this.takeoffLandArea.ilsType = this.setIlsType(this.formGroup.value.ilsType);
                        this.takeoffLandArea.gradient = this.formGroup.value.gradient;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._runwayService.postTakeoffLandArea(this.airportId, this.takeoffLandArea, this.runwayId)];
                    case 1:
                        result = _a.sent();
                        this.takeoffLandArea = TakeoffLandArea.parse(result);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._runwayService.putTakeoffLandArea(this.airportId, this.takeoffLandArea)];
                    case 3:
                        result = _a.sent();
                        this.takeoffLandArea = TakeoffLandArea.parse(result);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, takeoffLandArea: this.takeoffLandArea });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false, error: e_1 });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditTakeoffLandAreaComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditTakeoffLandAreaComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.takeoffLandArea, this.origtakeoffLandArea);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditTakeoffLandAreaComponent;
}());
export { EditTakeoffLandAreaComponent };
